<template>
    <div _tmplitem="43" class="dv-full-screen-container" :style="css">
        <div _tmplitem="43" style="position: absolute;--animation-linear:1;--animation-type:ease;width:1920px;height:1080px;background-color:rgba(20, 47, 74, 1);" class="div-full-screen">
            <div _tmplitem="43" v-if="readDataPermission.charttool5k2q" class="bigitem charttool5k2q " style="top: 460px; left: 29px;position: absolute; width: 441px; height: 251px; transform: translate(0px, 0px); z-index: 1017;pointer-events: auto;  ">
                <div _tmplitem="43" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <baseechart _tmplitem="1" ref="charttool5k2q" :val="fromData.charttool5k2q" mapcity="" mapcode="" orienttype="horizontal" :echartroll="false" :maxechartrollnum="8" :echartrolltime="2" :configechart="controlData.charttool5k2q" :w="441" :h="251" echartcode="widgetBarDoubleYaxis"></baseechart>
                </div>
            </div>
            <div _tmplitem="43" v-if="readDataPermission.charttoolpl1a" class="bigitem charttoolpl1a " style="top: 776px; left: 22px;position: absolute; width: 428px; height: 269px; transform: translate(0px, 0px); z-index: 1016;pointer-events: auto;  ">
                <div _tmplitem="43" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <baseechart _tmplitem="2" ref="charttoolpl1a" :val="fromData.charttoolpl1a" mapcity="" mapcode="" orienttype="horizontal" :echartroll="false" :maxechartrollnum="8" :echartrolltime="2" :configechart="controlData.charttoolpl1a" :w="428" :h="269" echartcode="widgetPiechart"></baseechart>
                </div>
            </div>
            <div _tmplitem="43" v-if="readDataPermission.charttoolxu53" class="bigitem charttoolxu53 " style="top: 448px; left: 1498px;position: absolute; width: 432px; height: 268px; transform: translate(0px, 0px); z-index: 1015;pointer-events: auto;  ">
                <div _tmplitem="43" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <baseechart _tmplitem="3" ref="charttoolxu53" :val="fromData.charttoolxu53" mapcity="" mapcode="" orienttype="horizontal" :echartroll="false" :maxechartrollnum="8" :echartrolltime="2" :configechart="controlData.charttoolxu53" :w="432" :h="268" echartcode="widgetBarlinechart"></baseechart>
                </div>
            </div>
            <div _tmplitem="43" v-if="readDataPermission.charttoolxmf5" class="bigitem charttoolxmf5 " style="top: 173px; left: 1496px;position: absolute; width: 438px; height: 234px; transform: translate(0px, 0px); z-index: 1014;pointer-events: auto;  ">
                <div _tmplitem="43" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <baseechart _tmplitem="4" ref="charttoolxmf5" :val="fromData.charttoolxmf5" mapcity="" mapcode="" orienttype="horizontal" :echartroll="false" :maxechartrollnum="8" :echartrolltime="2" :configechart="controlData.charttoolxmf5" :w="438" :h="234" echartcode="widgetLinechart"></baseechart>
                </div>
            </div>
            <div _tmplitem="43" v-if="readDataPermission.charttooltq94" class="bigitem charttooltq94 " style="top: 773px; left: 1490px;position: absolute; width: 414px; height: 259px; transform: translate(0px, 0px); z-index: 1013;pointer-events: auto;  ">
                <div _tmplitem="43" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <baseechart _tmplitem="5" ref="charttooltq94" :val="fromData.charttooltq94" mapcity="" mapcode="" orienttype="horizontal" :echartroll="false" :maxechartrollnum="8" :echartrolltime="2" :configechart="controlData.charttooltq94" :w="414" :h="259" echartcode="widgetBarStack"></baseechart>
                </div>
            </div>
            <div _tmplitem="43" v-if="readDataPermission.gropa39a" class="gropa39a " style="overflow: hidden; width: 389px; height: 269px;top: 112px; left: -6px;position: absolute; z-index: 1012;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
                <div _tmplitem="43" class="" style=" width: 389px; height: 269px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
                    <div _tmplitem="15" v-if="readDataPermission.numeojk" class="bigitem numeojk " style="top: 235.27999999999997px; left: 255.12px; position: absolute;width: 105.88px; height: 33.72px; transform: translate(0px, 0px); z-index: 109;pointer-events: auto;  ">
                        <div _tmplitem="15" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(228, 74, 8, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <digitalflop _tmplitem="6" ref="numeojk" :num="fromData.numeojk" content="{nt} 亿元" :w="105.88" :h="33.72" :len="0" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(228, 74, 8, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></digitalflop>
                        </div>
                    </div>
                    <div _tmplitem="15" v-if="readDataPermission.num274l" class="bigitem num274l " style="top: 152.57999999999998px; left: 254.02999999999997px; position: absolute;width: 105.88px; height: 33.72px; transform: translate(0px, 0px); z-index: 108;pointer-events: auto;  ">
                        <div _tmplitem="15" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(8, 184, 228, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <digitalflop _tmplitem="7" ref="num274l" :num="fromData.num274l" content="{nt} 亿元" :w="105.88" :h="33.72" :len="0" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(8, 184, 228, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></digitalflop>
                        </div>
                    </div>
                    <div _tmplitem="15" v-if="readDataPermission.num30ks" class="bigitem num30ks " style="top: 85px; left: 267px; position: absolute;width: 100px; height: 49px; transform: translate(0px, 0px); z-index: 107;pointer-events: auto;  ">
                        <div _tmplitem="15" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(228, 158, 8, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <digitalflop _tmplitem="8" ref="num30ks" :num="fromData.num30ks" content="{nt} 亿元" :w="100" :h="49" :len="0" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(228, 158, 8, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></digitalflop>
                        </div>
                    </div>
                    <div _tmplitem="15" v-if="readDataPermission.titleuksa" class="bigitem titleuksa " style="top: 198.97000000000003px; left: 245.57999999999998px; position: absolute;width: 105.88px; height: 33.72px; transform: translate(0px, 0px); z-index: 106;pointer-events: auto;  ">
                        <div _tmplitem="15" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <titlecontrol _tmplitem="9" ref="titleuksa" :w="105.88" :h="33.72" :val="fromData.titleuksa" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
                        </div>
                    </div>
                    <div _tmplitem="15" v-if="readDataPermission.title474x" class="bigitem title474x " style="top: 122.24000000000001px; left: 250.88px; position: absolute;width: 105.88px; height: 33.72px; transform: translate(0px, 0px); z-index: 105;pointer-events: auto;  ">
                        <div _tmplitem="15" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <titlecontrol _tmplitem="10" ref="title474x" :w="105.88" :h="33.72" :val="fromData.title474x" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
                        </div>
                    </div>
                    <div _tmplitem="15" v-if="readDataPermission.title7yab" class="bigitem title7yab " style="top: 0px; left: 39px; position: absolute;width: 350px; height: 41px; transform: translate(0px, 0px); z-index: 104;pointer-events: auto;  ">
                        <div _tmplitem="15" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:18px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <titlecontrol _tmplitem="11" ref="title7yab" :w="350" :h="41" :val="fromData.title7yab" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:18px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);    box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px;
    background-image: linear-gradient(to right, rgba(30, 195, 255, 0.64), rgba(255, 255, 255, 0));
    border-radius: 16px;
    border: 0px solid rgba(30, 161, 255, 0.59);
    padding-left: 12px;"></titlecontrol>
                        </div>
                    </div>
                    <div _tmplitem="15" v-if="readDataPermission.title332a" class="bigitem title332a " style="top: 223.43px; left: 71.41px; position: absolute;width: 105.88px; height: 33.72px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
                        <div _tmplitem="15" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:20px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <titlecontrol _tmplitem="12" ref="title332a" :w="105.88" :h="33.72" :val="fromData.title332a" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:20px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
                        </div>
                    </div>
                    <div _tmplitem="15" v-if="readDataPermission.chartuq0d" class="bigitem chartuq0d " style="top: 48px; left: 0px; position: absolute;width: 248.86px; height: 172.93px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
                        <div _tmplitem="15" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;filter:saturate(1) contrast(1) hue-rotate(325deg) brightness(1) blur(0px);transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <myechart _tmplitem="13" ref="chartuq0d" orienttype="horizontal" :echartroll="false" :maxechartrollnum="8" :echartrolltime="2" mapcity="" mapcode="" mapurl="" :options="fromData.chartuq0d"></myechart>
                        </div>
                    </div>
                    <div _tmplitem="15" v-if="readDataPermission.title7ooz" class="bigitem title7ooz " style="top: 48px; left: 254.02999999999997px; position: absolute;width: 105.88px; height: 33.72px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
                        <div _tmplitem="15" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <titlecontrol _tmplitem="14" ref="title7ooz" :w="105.88" :h="33.72" :val="fromData.title7ooz" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
                        </div>
                    </div>
                </div>
            </div>
            <div _tmplitem="43" v-if="readDataPermission.titlejyqs" class="bigitem titlejyqs " style="top: 720px; left: 1505px;position: absolute; width: 350px; height: 34px; transform: translate(0px, 0px); z-index: 1011;pointer-events: auto;  ">
                <div _tmplitem="43" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:18px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <titlecontrol _tmplitem="16" ref="titlejyqs" :w="350" :h="34" :val="fromData.titlejyqs" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:18px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);    box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px;
    background-image: linear-gradient(to right, rgba(30, 195, 255, 0.64), rgba(255, 255, 255, 0));
    border-radius: 16px;
    border: 0px solid rgba(30, 161, 255, 0.59);
    padding-left: 12px;"></titlecontrol>
                </div>
            </div>
            <div _tmplitem="43" v-if="readDataPermission.titlewt45" class="bigitem titlewt45 " style="top: 416px; left: 1515px;position: absolute; width: 350px; height: 34px; transform: translate(0px, 0px); z-index: 1010;pointer-events: auto;  ">
                <div _tmplitem="43" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:18px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <titlecontrol _tmplitem="17" ref="titlewt45" :w="350" :h="34" :val="fromData.titlewt45" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:18px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);    box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px;
    background-image: linear-gradient(to right, rgba(30, 195, 255, 0.64), rgba(255, 255, 255, 0));
    border-radius: 16px;
    border: 0px solid rgba(30, 161, 255, 0.59);
    padding-left: 12px;"></titlecontrol>
                </div>
            </div>
            <div _tmplitem="43" v-if="readDataPermission.titleu3s0" class="bigitem titleu3s0 " style="top: 134px; left: 1513px;position: absolute; width: 350px; height: 34px; transform: translate(0px, 0px); z-index: 109;pointer-events: auto;  ">
                <div _tmplitem="43" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:18px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <titlecontrol _tmplitem="18" ref="titleu3s0" :w="350" :h="34" :val="fromData.titleu3s0" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:18px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);    box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px;
    background-image: linear-gradient(to right, rgba(30, 195, 255, 0.64), rgba(255, 255, 255, 0));
    border-radius: 16px;
    border: 0px solid rgba(30, 161, 255, 0.59);
    padding-left: 12px;"></titlecontrol>
                </div>
            </div>
            <div _tmplitem="43" v-if="readDataPermission.title3ywz" class="bigitem title3ywz " style="top: 719px; left: 34px;position: absolute; width: 350px; height: 34px; transform: translate(0px, 0px); z-index: 108;pointer-events: auto;  ">
                <div _tmplitem="43" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:18px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <titlecontrol _tmplitem="19" ref="title3ywz" :w="350" :h="34" :val="fromData.title3ywz" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:18px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);    box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px;
    background-image: linear-gradient(to right, rgba(30, 195, 255, 0.64), rgba(255, 255, 255, 0));
    border-radius: 16px;
    border: 0px solid rgba(30, 161, 255, 0.59);
    padding-left: 12px;"></titlecontrol>
                </div>
            </div>
            <div _tmplitem="43" v-if="readDataPermission.titlek353" class="bigitem titlek353 " style="top: 414px; left: 35px;position: absolute; width: 350px; height: 34px; transform: translate(0px, 0px); z-index: 107;pointer-events: auto;  ">
                <div _tmplitem="43" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:18px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <titlecontrol _tmplitem="20" ref="titlek353" :w="350" :h="34" :val="fromData.titlek353" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:18px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);    box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px;
    background-image: linear-gradient(to right, rgba(30, 195, 255, 0.64), rgba(255, 255, 255, 0));
    border-radius: 16px;
    border: 0px solid rgba(30, 161, 255, 0.59);
    padding-left: 12px;"></titlecontrol>
                </div>
            </div>
            <div _tmplitem="43" v-if="readDataPermission.titlee8mw" class="bigitem titlee8mw " style="top: 118px; left: 800px;position: absolute; width: 250px; height: 40px; transform: translate(0px, 0px); z-index: 106;pointer-events: auto;  ">
                <div _tmplitem="43" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:20px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <titlecontrol _tmplitem="21" ref="titlee8mw" :w="250" :h="40" :val="fromData.titlee8mw" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:20px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
                </div>
            </div>
            <div _tmplitem="43" v-if="readDataPermission.num259s0" class="bigitem num259s0 " style="top: 193px; left: 731px;position: absolute; width: 523px; height: 62px; transform: translate(0px, 0px); z-index: 105;pointer-events: auto;  ">
                <div _tmplitem="43" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgb(255, 255, 255) ;background-color:rgba(8, 70, 128, 1);text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <numscroll2 _tmplitem="22" :val="fromData.num259s0" w="523" :len="8" :h="62" backgroundcolor="" bordercolor="" fontcolor="rgb(255, 255, 255)"></numscroll2>
                </div>
            </div>
            <div _tmplitem="43" v-if="readDataPermission.sel171443877146139" class="bigitem sel171443877146139 " style="top: 18px; left: 754px;position: absolute; width: 423px; height: 39px; transform: translate(0px, 0px); z-index: 104;pointer-events: auto;  ">
                <div _tmplitem="43" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:30px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <titlecontrol _tmplitem="23" ref="sel171443877146139" :w="423" :h="39" :val="fromData.sel171443877146139" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:30px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:center;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
                </div>
            </div>
            <div _tmplitem="43" v-if="readDataPermission.gropapgy" class="gropapgy " style="overflow: hidden; width: 1026px; height: 544px;top: 279px; left: 490px;position: absolute; z-index: 103;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
                <div _tmplitem="43" class="" style=" width: 1026px; height: 544px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
                    <div _tmplitem="38" v-if="readDataPermission.numyjae" class="bigitem numyjae " style="top: 303px; left: 894px; position: absolute;width: 100px; height: 40px; transform: translate(0px, 0px); z-index: 1014;pointer-events: auto;  ">
                        <div _tmplitem="38" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(12, 195, 251, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <digitalflop _tmplitem="24" ref="numyjae" :num="fromData.numyjae" content="{nt}个" :w="100" :h="40" :len="0" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(12, 195, 251, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></digitalflop>
                        </div>
                    </div>
                    <div _tmplitem="38" v-if="readDataPermission.numfeav" class="bigitem numfeav " style="top: 206px; left: 926px; position: absolute;width: 100px; height: 40px; transform: translate(0px, 0px); z-index: 1013;pointer-events: auto;  ">
                        <div _tmplitem="38" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(12, 195, 251, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <digitalflop _tmplitem="25" ref="numfeav" :num="fromData.numfeav" content="{nt}个" :w="100" :h="40" :len="0" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(12, 195, 251, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></digitalflop>
                        </div>
                    </div>
                    <div _tmplitem="38" v-if="readDataPermission.numnrrv" class="bigitem numnrrv " style="top: 113px; left: 893px; position: absolute;width: 100px; height: 40px; transform: translate(0px, 0px); z-index: 1012;pointer-events: auto;  ">
                        <div _tmplitem="38" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(12, 195, 251, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <digitalflop _tmplitem="26" ref="numnrrv" :num="fromData.numnrrv" content="{nt}个" :w="100" :h="40" :len="0" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(12, 195, 251, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></digitalflop>
                        </div>
                    </div>
                    <div _tmplitem="38" v-if="readDataPermission.num567k" class="bigitem num567k " style="top: 302px; left: 190px; position: absolute;width: 100px; height: 40px; transform: translate(0px, 0px); z-index: 1011;pointer-events: auto;  ">
                        <div _tmplitem="38" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(12, 195, 251, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <digitalflop _tmplitem="27" ref="num567k" :num="fromData.num567k" content="{nt}个" :w="100" :h="40" :len="0" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(12, 195, 251, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></digitalflop>
                        </div>
                    </div>
                    <div _tmplitem="38" v-if="readDataPermission.num5rlv" class="bigitem num5rlv " style="top: 203px; left: 150px; position: absolute;width: 100px; height: 40px; transform: translate(0px, 0px); z-index: 1010;pointer-events: auto;  ">
                        <div _tmplitem="38" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(12, 195, 251, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <digitalflop _tmplitem="28" ref="num5rlv" :num="fromData.num5rlv" content="{nt}个" :w="100" :h="40" :len="0" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(12, 195, 251, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></digitalflop>
                        </div>
                    </div>
                    <div _tmplitem="38" v-if="readDataPermission.titlefj9r" class="bigitem titlefj9r " style="top: 299px; left: 783px; position: absolute;width: 100px; height: 40px; transform: translate(0px, 0px); z-index: 109;pointer-events: auto;  ">
                        <div _tmplitem="38" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <titlecontrol _tmplitem="29" ref="titlefj9r" :w="100" :h="40" :val="fromData.titlefj9r" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
                        </div>
                    </div>
                    <div _tmplitem="38" v-if="readDataPermission.titlef9tz" class="bigitem titlef9tz " style="top: 109px; left: 59px; position: absolute;width: 100px; height: 40px; transform: translate(0px, 0px); z-index: 108;pointer-events: auto;  ">
                        <div _tmplitem="38" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <titlecontrol _tmplitem="30" ref="titlef9tz" :w="100" :h="40" :val="fromData.titlef9tz" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
                        </div>
                    </div>
                    <div _tmplitem="38" v-if="readDataPermission.num67rw" class="bigitem num67rw " style="top: 108px; left: 178px; position: absolute;width: 100px; height: 40px; transform: translate(0px, 0px); z-index: 107;pointer-events: auto;  ">
                        <div _tmplitem="38" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(12, 195, 251, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <digitalflop _tmplitem="31" ref="num67rw" :num="fromData.num67rw" content="{nt}个" :w="100" :h="40" :len="0" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(12, 195, 251, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-weight:bold ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></digitalflop>
                        </div>
                    </div>
                    <div _tmplitem="38" v-if="readDataPermission.titlewtpl" class="bigitem titlewtpl " style="top: 111px; left: 788px; position: absolute;width: 100px; height: 40px; transform: translate(0px, 0px); z-index: 106;pointer-events: auto;  ">
                        <div _tmplitem="38" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <titlecontrol _tmplitem="32" ref="titlewtpl" :w="100" :h="40" :val="fromData.titlewtpl" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
                        </div>
                    </div>
                    <div _tmplitem="38" v-if="readDataPermission.titlem074" class="bigitem titlem074 " style="top: 209px; left: 812px; position: absolute;width: 100px; height: 40px; transform: translate(0px, 0px); z-index: 105;pointer-events: auto;  ">
                        <div _tmplitem="38" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <titlecontrol _tmplitem="33" ref="titlem074" :w="100" :h="40" :val="fromData.titlem074" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
                        </div>
                    </div>
                    <div _tmplitem="38" v-if="readDataPermission.titles3zr" class="bigitem titles3zr " style="top: 300px; left: 60px; position: absolute;width: 130px; height: 40px; transform: translate(0px, 0px); z-index: 104;pointer-events: auto;  ">
                        <div _tmplitem="38" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <titlecontrol _tmplitem="34" ref="titles3zr" :w="130" :h="40" :val="fromData.titles3zr" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
                        </div>
                    </div>
                    <div _tmplitem="38" v-if="readDataPermission.titlec8s2" class="bigitem titlec8s2 " style="top: 203px; left: 33px; position: absolute;width: 100px; height: 40px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
                        <div _tmplitem="38" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <titlecontrol _tmplitem="35" ref="titlec8s2" :w="100" :h="40" :val="fromData.titlec8s2" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
                        </div>
                    </div>
                    <div _tmplitem="38" v-if="readDataPermission.lab2fbp" class="bigitem lab2fbp " style="top: 5px; left: 98px; position: absolute;width: 797px; height: 458px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
                        <div _tmplitem="38" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <custom1949989328457355266 ref="lab2fbp" w="797" h="458" :iscomzoom="true" :initwidth="0" :initheight="0" comid="1949989328457355266" color="rgba(8, 241, 225, 1)" detail="1" particlesizemax="0.1" particlesizemin="0.05"></custom1949989328457355266>
                        </div>
                    </div>
                    <div _tmplitem="38" v-if="readDataPermission.img1jxh" class="bigitem img1jxh " style="top: 0px; left: 0px; position: absolute;width: 1000px; height: 544px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
                        <div _tmplitem="38" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <bigimg _tmplitem="37" url="/img1949998322924179457/ad5a56c3-f8b5-45b8-b04e-f3a6f94b06e9.png" w="1000" h="544" rotatetype="" rotatetime=""></bigimg>
                        </div>
                    </div>
                </div>
            </div>
            <div _tmplitem="43" v-if="readDataPermission.grop17144387495475" class="grop17144387495475 " style="overflow: hidden; width: 1920px; height: 104px;top: 0px; left: 0px;position: absolute; z-index: 102;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
                <div _tmplitem="43" class="" style=" width: 1920px; height: 104px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;">
                    <div _tmplitem="41" v-if="readDataPermission.sel171443848275890" class="bigitem sel171443848275890 " style="top: 0px; left: 0px; position: absolute;width: 1920px; height: 104px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
                        <div _tmplitem="41" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <bigimg _tmplitem="39" url="/img1949998322924179457/7e543c6a-e28b-4461-9939-1847e5104c0b.png" w="1920" h="104" rotatetype="" rotatetime=""></bigimg>
                        </div>
                    </div>
                    <div _tmplitem="41" v-if="readDataPermission.sel171443870260087" class="bigitem sel171443870260087 " style="top: 0px; left: 0px; position: absolute;width: 1920px; height: 104px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  --objectfit:cover">
                        <div _tmplitem="41" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"> <video _tmplitem="40" class="art-video" preload="metadata" crossorigin="anonymous" src="/img1949998322924179457/charts-img-db_id_4l0pkjqwbrw000.webm" autoplay="autoplay" loop="loop" muted="true" style="width:1920px;height:104px"></video> </div>
                    </div>
                </div>
            </div>
            <div _tmplitem="43" v-if="readDataPermission.labjf0o" class="bigitem labjf0o bigechartitem" style="top: 306px; left: 0px;position: absolute; width: 1920px; height: 776px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
                <div _tmplitem="43" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <custom1949993436471939073 ref="labjf0o" w="1920" h="776" :iscomzoom="true" :initwidth="0" :initheight="0" comid="1949993436471939073"></custom1949993436471939073>
                </div>
            </div>
        </div>
        <fromdialog _tmplitem="43" ref="reffromdialog"></fromdialog>
    </div>
</template>
<script>
    import custom1949993436471939073 from './custom1949993436471939073.vue'
    import custom1949989328457355266 from './custom1949989328457355266.vue'
    export default {
        methods: {
            created_sys() {
                ///系统方法 判断页面大小 使其自动适应
                let $this = this
                this.w = this.w === undefined ? 1920 : this.w
                $this.css = $this.fullScreenCss($this, this.screentype)
                window.addEventListener('resize', () => {
                    $this.css = $this.fullScreenCss($this, this.screentype)
                })
                if (this.loadfunmounted_sys !== undefined) {
                    this.$nextTick(() => {
                        this.loadfunmounted_sys()
                    })
                }
            },
            loadsysmounted() {},
            fullScreenCss(t, e) {
                if ("none" === e) return `  width: ${t.w}px;height: ${t.h}px; ${""===t.bg?"":"background-image:url("+t.bg+");    background-repeat: no-repeat;background-size: cover;"}    ${""===t.bgColor?"":"background-color:"+t.bgColor+";"}`;
                if ("w" === e) return `  width: ${t.w}px;height: ${t.h}px; ${""===t.bg?"":"background-image:url("+t.bg+");    background-repeat: no-repeat;background-size: cover;"}  transform: scale(${document.body.clientWidth/t.w});  ${""===t.bgColor?"":"background-color:"+t.bgColor+";"}`;
                if ("h" === e) return `  width: ${t.w}px;height: ${t.h}px; ${""===t.bg?"":"background-image:url("+t.bg+");    background-repeat: no-repeat;background-size: cover;"}  transform: scale(${document.body.clientHeight/t.h});  ${""===t.bgColor?"":"background-color:"+t.bgColor+";"}`;
                if ("full" === e) return `  width: ${t.w}px;height: ${t.h}px; ${""===t.bg?"":"background-image:url("+t.bg+");    background-repeat: no-repeat;background-size: cover;"}  transform: scale(${document.body.clientWidth/t.w},${document.body.clientHeight/t.h});  ${""===t.bgColor?"":"background-color:"+t.bgColor+";"}`; {
                    let e = document.body.clientHeight / t.h,
                        n = document.body.clientWidth / t.w,
                        i = e > n ? n : e,
                        o = (document.body.clientWidth - i * t.w) / 2;
                    return o = o > 0 ? "left:" + o + "px;" : "", o + ` transform: scale(${i}); width: ${t.w}px;height: ${t.h}px; ${""===t.bg?"":"background-image:url("+t.bg+");    background-repeat: no-repeat;background-size: cover;"} ${""===t.bgColor?"":"background-color:"+t.bgColor+";"}`
                }
            },
            loadfunmounted_sys() {
                if (this.loadsysmounted !== undefined) {
                    this.loadsysmounted();
                }
                if (this.loadfunmounted !== undefined) {
                    let isreturn = this.loadfunmounted();
                    if (isreturn == false) {
                        return;
                    }
                }
            }
        },
        created() {
            this.created_sys();
        },
        data() {
            return {
                w: 1920,
                css: ``,
                h: 1080,
                bg: ``,
                bgColor: `rgba(20, 47, 74, 1)`,
                fromData: {
                    charttool5k2q: [{
                        axis: `1月`,
                        bar1: 2.6,
                        bar2: 2,
                        bar3: 2
                    }, {
                        axis: `2月`,
                        bar1: 3.6,
                        bar2: 2,
                        bar3: 1
                    }, {
                        axis: `3月`,
                        bar1: 4.6,
                        bar2: 3,
                        bar3: 2.9
                    }],
                    charttoolpl1a: [{
                        value: 1048,
                        name: `搜索引擎`
                    }, {
                        value: 735,
                        name: `直接访问`
                    }, {
                        value: 580,
                        name: `邮件营销`
                    }, {
                        value: 484,
                        name: `联盟广告`
                    }, {
                        value: 300,
                        name: `视频广告`
                    }],
                    charttoolxu53: [{
                        axis: `1月`,
                        bar: 2.6,
                        line: 2
                    }, {
                        axis: `2月`,
                        bar: 5.9,
                        line: 2.2
                    }, {
                        axis: `3月`,
                        bar: 9,
                        line: 3.3
                    }, {
                        axis: `4月`,
                        bar: 26.4,
                        line: 4.5
                    }, {
                        axis: `5月`,
                        bar: 28.7,
                        line: 6.3
                    }, {
                        axis: `6月`,
                        bar: 70.7,
                        line: 10.2
                    }, {
                        axis: `7月`,
                        bar: 175.6,
                        line: 20.3
                    }, {
                        axis: `8月`,
                        bar: 182.2,
                        line: 23.4
                    }, {
                        axis: `9月`,
                        bar: 48.7,
                        line: 23
                    }, {
                        axis: `10月`,
                        bar: 18.8,
                        line: 16.5
                    }, {
                        axis: `11月`,
                        bar: 6,
                        line: 12
                    }, {
                        axis: `12月`,
                        bar: 2.3,
                        line: 6.2
                    }],
                    charttoolxmf5: [{
                        axis: `苹果`,
                        data: 1000
                    }, {
                        axis: `三星`,
                        data: 2229
                    }, {
                        axis: `小米`,
                        data: 3879
                    }, {
                        axis: `oppo`,
                        data: 2379
                    }, {
                        axis: `vivo`,
                        data: 4079
                    }],
                    charttooltq94: [{
                        axis: `2021-07-25`,
                        name: `A`,
                        data: `12`
                    }, {
                        axis: `2021-07-25`,
                        name: `B`,
                        data: `20`
                    }, {
                        axis: `2021-07-26`,
                        name: `B`,
                        data: `5`
                    }, {
                        axis: `2021-07-27`,
                        name: `A`,
                        data: `15`
                    }, {
                        axis: `2021-07-27`,
                        name: `B`,
                        data: `30`
                    }],
                    numeojk: 140,
                    num274l: 360,
                    num30ks: 500,
                    titleuksa: `未完成`,
                    title474x: `已完成`,
                    title7yab: `一季度业绩概览`,
                    title332a: `达成率`,
                    chartuq0d: {
                        series: [{
                            type: `liquidFill`,
                            data: [0.6, 0.5, 0.4, 0.3],
                            radius: `80%`,
                            shape: `roundRect`,
                            center: [`50%`, `50%`],
                            backgroundStyle: {
                                borderColor: `rgba(8, 241, 225, 1)`,
                                borderWidth: 1,
                                shadowColor: `rgba(0, 0, 0, 0.4)`,
                                shadowBlur: 20
                            },
                            outline: {
                                show: false
                            },
                            waveAnimation: true
                        }]
                    },
                    title7ooz: `全年目标`,
                    titlejyqs: `注册申请`,
                    titlewt45: `不合格数量`,
                    titleu3s0: `抽查样品数量`,
                    title3ywz: `历年抽检次数`,
                    titlek353: `历年抽检次数`,
                    titlee8mw: `平台累计检验药品数量`,
                    num259s0: 1343,
                    sel171443877146139: `药品大数据监管平台`,
                    numyjae: 20,
                    numfeav: 8,
                    numnrrv: 13,
                    num567k: 18,
                    num5rlv: 34,
                    titlefj9r: `三类药品企业`,
                    titlef9tz: `药品生产企业`,
                    num67rw: 45,
                    titlewtpl: `一类药品企业`,
                    titlem074: `二类药品企业`,
                    titles3zr: `化妆品生产企业`,
                    titlec8s2: `医疗器械企业`
                },
                controlTimer: {},
                controlData: {
                    charttool5k2q: {
                        isShowTitle: true,
                        text: ``,
                        textColor: `#fff`,
                        textFontSize: 20,
                        textFontWeight: `normal`,
                        textFontStyle: `normal`,
                        textFontFamily: `sans-serif`,
                        subtext: ``,
                        subtextColor: `#fff`,
                        subtextFontSize: 20,
                        subtextFontWeight: `normal`,
                        subtextFontStyle: `normal`,
                        subtextFontFamily: `sans-serif`,
                        titleLeft: `center`,
                        titleTop: 5,
                        titleItemGap: 0,
                        maxWidth: 15,
                        radius: 5,
                        barGap: 10,
                        minHeight: 0,
                        isShowBackground: true,
                        backgroundStyleColor: `rgba(180, 180, 180, 0.2)`,
                        backgroundStyleBorderColor: `#000`,
                        backgroundStyleBorderWidth: 0,
                        backgroundStyleBorderType: `dashed`,
                        backgroundStyleShadowBlur: 10,
                        backgroundStyleShadowColor: `rgba(0, 0, 0, 0.5)`,
                        backgroundStyleOpacity: 100,
                        isShowX: true,
                        isShowAxisLabelX: true,
                        positionX: `bottom`,
                        offsetX: 0,
                        textColorX: `#fff`,
                        textFontSizeX: 14,
                        textFontWeightX: `normal`,
                        textFontStyleX: `normal`,
                        textFontFamilyX: `sans-serif`,
                        textRowsBreakAuto: false,
                        textRowsNum: ``,
                        textIntervalX: 0,
                        textAngleX: 0,
                        isShowAxisLineX: true,
                        reversalX: false,
                        lineColorX: `#fff`,
                        lineWidthX: 1,
                        nameX: ``,
                        nameLocationX: `end`,
                        nameColorX: `#fff`,
                        nameFontSizeX: 14,
                        nameFontWeightX: `normal`,
                        nameFontStyleX: `normal`,
                        nameFontFamilyX: `sans-serif`,
                        isShowSplitLineX: false,
                        splitLineColorX: `#fff`,
                        splitLineWidthX: 1,
                        isShowYLeft: true,
                        isShowAxisLabelYLeft: true,
                        maxYLeft: ``,
                        positionYLeft: `left`,
                        offsetYLeft: 0,
                        textColorYLeft: `#fff`,
                        textFontSizeYLeft: 14,
                        textFontWeightYLeft: `normal`,
                        textFontStyleYLeft: `normal`,
                        textFontFamilyYLeft: `sans-serif`,
                        scaleYLeft: false,
                        splitNumberYLeft: 0,
                        textAngleYLeft: 0,
                        isShowAxisLineYLeft: true,
                        lineColorYLeft: `#fff`,
                        lineWidthYLeft: 1,
                        textNameYLeft: ``,
                        nameLocationYLeft: `end`,
                        nameColorYLeft: `#fff`,
                        nameFontSizeYLeft: 14,
                        nameFontWeightYLeft: `normal`,
                        nameFontStyleYLeft: `normal`,
                        nameFontFamilyYLeft: `sans-serif`,
                        isShowSplitLineYLeft: false,
                        splitLineColorYLeft: `#fff`,
                        splitLineFontWidthYLeft: 1,
                        isShowYRight: false,
                        isShowAxisLabelYRight: true,
                        maxYRight: ``,
                        positionYRight: `right`,
                        textColorYRight: `#fff`,
                        textFontSizeYRight: 14,
                        textFontWeightYRight: `normal`,
                        textFontStyleYRight: `normal`,
                        textFontFamilyYRight: `sans-serif`,
                        scaleYRight: false,
                        splitNumberYRight: 0,
                        textAngleYRight: 0,
                        isShowAxisLineYRight: true,
                        lineColorYRight: `#fff`,
                        lineWidthYRight: 1,
                        textNameYRight: ``,
                        nameLocationYRight: `end`,
                        nameColorYRight: `#fff`,
                        nameFontSizeYRight: 14,
                        nameFontWeightYRight: `normal`,
                        nameFontStyleYRight: `normal`,
                        nameFontFamilyYRight: `sans-serif`,
                        isShowSplitLineYRight: false,
                        splitLineColorYRight: `#fff`,
                        splitLineFontWidthYRight: 1,
                        isShowLegend: true,
                        legendName: ``,
                        legendColor: `#fff`,
                        legendFontSize: 12,
                        legendFontWeight: `normal`,
                        legendFontStyle: `normal`,
                        legendFontFamily: `sans-serif`,
                        legendWidth: 12,
                        legendHeight: 12,
                        lateralPosition: `center`,
                        longitudinalPosition: `top`,
                        layoutFront: `horizontal`,
                        isShow: false,
                        percentSign: false,
                        fontPosition: `top`,
                        fontDistance: -10,
                        fontColor: `#fff`,
                        fontSize: 12,
                        fontWeight: `normal`,
                        fontStyle: `normal`,
                        fontFamily: `sans-serif`,
                        isShowTooltip: true,
                        tooltipTrigger: `axis`,
                        tooltipAxisPointerType: `shadow`,
                        tooltipFontSize: 16,
                        tooltipColor: `#00FEFF`,
                        tooltipFontWeight: `normal`,
                        tooltipFontStyle: `normal`,
                        tooltipFontFamily: `sans-serif`,
                        marginLeft: 10,
                        marginRight: 50,
                        marginTop: 50,
                        marginBottom: 10,
                        customColor: [{
                            color: `rgb(73, 146, 255)`
                        }, {
                            color: `rgb(124, 255, 178)`
                        }, {
                            color: `rgb(253, 221, 96)`
                        }, {
                            color: `rgb(255, 110, 118)`
                        }, {
                            color: `rgb(88, 217, 249)`
                        }, {
                            color: `rgb(5, 192, 145)`
                        }],
                        tipsColor: `#fff`,
                        textColorY: `#fff`,
                        lineColorY: `#fff`
                    },
                    charttoolpl1a: {
                        isShowTitle: true,
                        text: ``,
                        textColor: `#fff`,
                        textFontSize: 20,
                        textFontWeight: `normal`,
                        textFontStyle: `normal`,
                        textFontFamily: `sans-serif`,
                        subtext: ``,
                        subtextColor: `#fff`,
                        subtextFontSize: 20,
                        subtextFontWeight: `normal`,
                        subtextFontStyle: `normal`,
                        subtextFontFamily: `sans-serif`,
                        titleLeft: `center`,
                        titleTop: 5,
                        titleItemGap: 0,
                        innerNumber: 30,
                        outerNumber: 60,
                        clockwise: true,
                        startAngle: 90,
                        minAngle: 0,
                        minShowLabelAngle: 0,
                        borderRadius: 10,
                        isShowEmphasisLabel: true,
                        emphasisLabelFontSize: 24,
                        emphasisLabelFontColor: ``,
                        emphasisLabelFontWeight: `bold`,
                        emphasisLabelFontStyle: `normal`,
                        emphasisLabelFontFamily: `sans-serif`,
                        borderColor: ``,
                        borderWidth: 1,
                        borderType: `solid`,
                        shadowBlur: 10,
                        shadowColor: `rgba(0, 0, 0, 0.5)`,
                        isShowLegend: true,
                        legendColor: `#fff`,
                        legendFontSize: 12,
                        legendFontWeight: `normal`,
                        legendFontStyle: `normal`,
                        legendFontFamily: `sans-serif`,
                        legendWidth: 12,
                        legendHeight: 12,
                        lateralPosition: `center`,
                        longitudinalPosition: `top`,
                        layoutFront: `horizontal`,
                        isShow: true,
                        numberValue: true,
                        percentage: false,
                        percentPrecision: 2,
                        position: `outside`,
                        padding: 0,
                        rotate: 0,
                        fontSize: 12,
                        fontColor: `#fff`,
                        fontWeight: `normal`,
                        fontStyle: `normal`,
                        fontFamily: `sans-serif`,
                        isShowLabelLine: true,
                        labelLineSmooth: false,
                        labelLineLength: 5,
                        labelLineLength2: 15,
                        lineStyleColor: ``,
                        lineStyleWidth: 1,
                        lineStyleType: `solid`,
                        isShowTooltip: true,
                        tooltipBackgroundColor: `#333`,
                        tooltipFontSize: 16,
                        tooltipColor: `#00FEFF`,
                        tooltipFontWeight: `normal`,
                        tooltipFontStyle: `normal`,
                        tooltipFontFamily: `sans-serif`,
                        tooltipBorderColor: `#333`,
                        tooltipBorderWidth: 0,
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                        customColor: [{
                            color: `rgb(73, 146, 255)`
                        }, {
                            color: `rgb(124, 255, 178)`
                        }, {
                            color: `rgb(253, 221, 96)`
                        }, {
                            color: `rgb(255, 110, 118)`
                        }, {
                            color: `rgb(88, 217, 249)`
                        }, {
                            color: `rgb(5, 192, 145)`
                        }],
                        tipsColor: `#fff`,
                        textColorX: `#fff`,
                        textColorY: `#fff`,
                        lineColorY: `#fff`,
                        lineColorX: `#fff`
                    },
                    charttoolxu53: {
                        isShowTitle: true,
                        text: ``,
                        textColor: `#fff`,
                        textFontSize: 20,
                        textFontWeight: `normal`,
                        textFontStyle: `normal`,
                        textFontFamily: `sans-serif`,
                        subtext: ``,
                        subtextColor: `#fff`,
                        subtextFontSize: 20,
                        subtextFontWeight: `normal`,
                        subtextFontStyle: `normal`,
                        subtextFontFamily: `sans-serif`,
                        titleLeft: `center`,
                        titleTop: 5,
                        titleItemGap: 0,
                        maxWidth: 15,
                        radius: 5,
                        minHeight: 0,
                        isShowBackground: true,
                        backgroundStyleColor: `rgba(180, 180, 180, 0.2)`,
                        backgroundStyleBorderColor: `#000`,
                        backgroundStyleBorderWidth: 0,
                        backgroundStyleBorderType: `dashed`,
                        backgroundStyleShadowBlur: 10,
                        backgroundStyleShadowColor: `rgba(0, 0, 0, 0.5)`,
                        backgroundStyleOpacity: 100,
                        markPoint: true,
                        pointSize: 5,
                        symbol: `circle`,
                        smoothCurve: false,
                        lineWidth: 5,
                        area: true,
                        areaThickness: 15,
                        isShowX: true,
                        isShowAxisLabelX: true,
                        positionX: `bottom`,
                        offsetX: 0,
                        textColorX: `#fff`,
                        textFontSizeX: 14,
                        textFontWeightX: `normal`,
                        textFontStyleX: `normal`,
                        textFontFamilyX: `sans-serif`,
                        textRowsBreakAuto: false,
                        textRowsNum: ``,
                        textIntervalX: 0,
                        textAngleX: 0,
                        isShowAxisLineX: true,
                        reversalX: false,
                        lineColorX: `#fff`,
                        lineWidthX: 1,
                        nameX: ``,
                        nameLocationX: `end`,
                        nameColorX: `#fff`,
                        nameFontSizeX: 14,
                        nameFontWeightX: `normal`,
                        nameFontStyleX: `normal`,
                        nameFontFamilyX: `sans-serif`,
                        isShowSplitLineX: false,
                        splitLineColorX: `#fff`,
                        splitLineWidthX: 1,
                        isShowYLeft: true,
                        isShowAxisLabelYLeft: true,
                        maxYLeft: ``,
                        positionYLeft: `left`,
                        offsetYLeft: 0,
                        textColorYLeft: `#fff`,
                        textFontSizeYLeft: 14,
                        textFontWeightYLeft: `normal`,
                        textFontStyleYLeft: `normal`,
                        textFontFamilyYLeft: `sans-serif`,
                        scaleYLeft: false,
                        splitNumberYLeft: 0,
                        textAngleYLeft: 0,
                        isShowAxisLineYLeft: true,
                        lineColorYLeft: `#fff`,
                        lineWidthYLeft: 1,
                        textNameYLeft: ``,
                        nameLocationYLeft: `end`,
                        nameColorYLeft: `#fff`,
                        nameFontSizeYLeft: 14,
                        nameFontWeightYLeft: `normal`,
                        nameFontStyleYLeft: `normal`,
                        nameFontFamilyYLeft: `sans-serif`,
                        isShowSplitLineYLeft: false,
                        splitLineColorYLeft: `#fff`,
                        splitLineFontWidthYLeft: 1,
                        isShowYRight: true,
                        isShowAxisLabelYRight: true,
                        maxYRight: ``,
                        positionYRight: `right`,
                        textColorYRight: `#fff`,
                        textFontSizeYRight: 14,
                        textFontWeightYRight: `normal`,
                        textFontStyleYRight: `normal`,
                        textFontFamilyYRight: `sans-serif`,
                        scaleYRight: false,
                        splitNumberYRight: 0,
                        textAngleYRight: 0,
                        isShowAxisLineYRight: true,
                        lineColorYRight: `#fff`,
                        lineWidthYRight: 1,
                        textNameYRight: ``,
                        nameLocationYRight: `end`,
                        nameColorYRight: `#fff`,
                        nameFontSizeYRight: 14,
                        nameFontWeightYRight: `normal`,
                        nameFontStyleYRight: `normal`,
                        nameFontFamilyYRight: `sans-serif`,
                        isShowSplitLineYRight: false,
                        splitLineColorYRight: `#fff`,
                        splitLineFontWidthYRight: 1,
                        isShowLegend: true,
                        legendName: ``,
                        legendColor: `#fff`,
                        legendFontSize: 12,
                        legendFontWeight: `normal`,
                        legendFontStyle: `normal`,
                        legendFontFamily: `sans-serif`,
                        legendWidth: 12,
                        legendHeight: 12,
                        lateralPosition: `center`,
                        longitudinalPosition: `top`,
                        layoutFront: `horizontal`,
                        isShowBar: false,
                        percentSignBar: false,
                        fontPositionBar: `top`,
                        fontDistanceBar: 0,
                        fontColorBar: ``,
                        fontSizeBar: 12,
                        fontWeightBar: `normal`,
                        fontStyleBar: `normal`,
                        fontFamilyBar: `sans-serif`,
                        isShowLine: false,
                        percentSignLine: false,
                        fontPositionLine: `top`,
                        fontDistanceLine: 0,
                        fontColorLine: ``,
                        fontSizeLine: 12,
                        fontWeightLine: `normal`,
                        fontStyleLine: `normal`,
                        fontFamilyLine: `sans-serif`,
                        isShowTooltip: true,
                        tooltipTrigger: `axis`,
                        tooltipAxisPointerType: `shadow`,
                        tooltipFontSize: 16,
                        tooltipColor: `#00FEFF`,
                        tooltipFontWeight: `normal`,
                        tooltipFontStyle: `normal`,
                        tooltipFontFamily: `sans-serif`,
                        marginLeft: 10,
                        marginRight: 50,
                        marginTop: 50,
                        marginBottom: 10,
                        customColor: [{
                            color: `rgb(73, 146, 255)`
                        }, {
                            color: `rgb(124, 255, 178)`
                        }, {
                            color: `rgb(253, 221, 96)`
                        }, {
                            color: `rgb(255, 110, 118)`
                        }, {
                            color: `rgb(88, 217, 249)`
                        }, {
                            color: `rgb(5, 192, 145)`
                        }],
                        fontColor: `#fff`,
                        tipsColor: `#fff`,
                        textColorY: `#fff`,
                        lineColorY: `#fff`
                    },
                    charttoolxmf5: {
                        isShowTitle: true,
                        text: ``,
                        textColor: `#fff`,
                        textFontSize: 20,
                        textFontWeight: `normal`,
                        textFontStyle: `normal`,
                        textFontFamily: `sans-serif`,
                        subtext: ``,
                        subtextColor: `#fff`,
                        subtextFontSize: 20,
                        subtextFontWeight: `normal`,
                        subtextFontStyle: `normal`,
                        subtextFontFamily: `sans-serif`,
                        titleLeft: `center`,
                        titleTop: 5,
                        titleItemGap: 0,
                        markPoint: true,
                        pointSize: 5,
                        symbol: `circle`,
                        smoothCurve: true,
                        lineWidth: 5,
                        area: true,
                        areaThickness: 15,
                        isShowX: true,
                        isShowAxisLabelX: true,
                        positionX: `bottom`,
                        offsetX: 0,
                        textColorX: `#fff`,
                        textFontSizeX: 14,
                        textFontWeightX: `normal`,
                        textFontStyleX: `normal`,
                        textFontFamilyX: `sans-serif`,
                        textRowsBreakAuto: false,
                        textRowsNum: ``,
                        textIntervalX: 0,
                        textAngleX: 0,
                        isShowAxisLineX: true,
                        reversalX: false,
                        lineColorX: `#fff`,
                        lineWidthX: 1,
                        nameX: ``,
                        nameLocationX: `end`,
                        nameColorX: `#fff`,
                        nameFontSizeX: 14,
                        nameFontWeightX: `normal`,
                        nameFontStyleX: `normal`,
                        nameFontFamilyX: `sans-serif`,
                        isShowSplitLineX: false,
                        splitLineColorX: `#fff`,
                        splitLineWidthX: 1,
                        isShowY: true,
                        isShowAxisLabelY: true,
                        maxY: ``,
                        positionY: `left`,
                        offsetY: 0,
                        textColorY: `#fff`,
                        textFontSizeY: 14,
                        textFontWeightY: `normal`,
                        textFontStyleY: `normal`,
                        textFontFamilyY: `sans-serif`,
                        scale: false,
                        splitNumberY: 0,
                        textAngleY: 0,
                        isShowAxisLineY: true,
                        reversalY: false,
                        lineColorY: `#fff`,
                        lineWidthY: 1,
                        textNameY: ``,
                        nameLocationY: `end`,
                        nameColorY: `#fff`,
                        nameFontSizeY: 14,
                        nameFontWeightY: `normal`,
                        nameFontStyleY: `normal`,
                        nameFontFamilyY: `sans-serif`,
                        isShowSplitLineY: false,
                        splitLineColorY: `#fff`,
                        splitLineWidthY: 1,
                        isShowLegend: true,
                        legendName: ``,
                        legendColor: `#fff`,
                        legendFontSize: 12,
                        legendFontWeight: `normal`,
                        legendFontStyle: `normal`,
                        legendFontFamily: `sans-serif`,
                        legendWidth: 12,
                        legendHeight: 12,
                        lateralPosition: `center`,
                        longitudinalPosition: `top`,
                        layoutFront: `horizontal`,
                        isShow: false,
                        percentSign: false,
                        fontPosition: `top`,
                        fontDistance: 0,
                        fontColor: `#fff`,
                        fontSize: 12,
                        fontWeight: `normal`,
                        fontStyle: `normal`,
                        fontFamily: `sans-serif`,
                        isShowTooltip: true,
                        tooltipTrigger: `axis`,
                        tooltipAxisPointerType: `shadow`,
                        tooltipFontSize: 16,
                        tooltipColor: `#00FEFF`,
                        tooltipFontWeight: `normal`,
                        tooltipFontStyle: `normal`,
                        tooltipFontFamily: `sans-serif`,
                        marginLeft: 10,
                        marginRight: 50,
                        marginTop: 50,
                        marginBottom: 10,
                        customColor: [{
                            color: `rgb(253, 221, 96)`
                        }, {
                            color: `rgb(255, 110, 118)`
                        }, {
                            color: `rgb(88, 217, 249)`
                        }, {
                            color: `rgb(5, 192, 145)`
                        }],
                        tipsColor: `#fff`
                    },
                    charttooltq94: {
                        verticalShow: false,
                        stackStyle: `upDown`,
                        isShowTitle: true,
                        text: ``,
                        textColor: `#fff`,
                        textFontSize: 20,
                        textFontWeight: `normal`,
                        textFontStyle: `normal`,
                        textFontFamily: `sans-serif`,
                        subtext: ``,
                        subtextColor: `#fff`,
                        subtextFontSize: 20,
                        subtextFontWeight: `normal`,
                        subtextFontStyle: `normal`,
                        subtextFontFamily: `sans-serif`,
                        titleLeft: `center`,
                        titleTop: 5,
                        titleItemGap: 0,
                        maxWidth: 15,
                        radius: 5,
                        barGap: 10,
                        minHeight: 0,
                        isShowBackground: true,
                        backgroundStyleColor: `rgba(180, 180, 180, 0.2)`,
                        backgroundStyleBorderColor: `#000`,
                        backgroundStyleBorderWidth: 0,
                        backgroundStyleBorderType: `dashed`,
                        backgroundStyleShadowBlur: 10,
                        backgroundStyleShadowColor: `rgba(0, 0, 0, 0.5)`,
                        backgroundStyleOpacity: 100,
                        isShowX: true,
                        isShowAxisLabelX: true,
                        positionX: `bottom`,
                        offsetX: 0,
                        textColorX: `#fff`,
                        textFontSizeX: 14,
                        textFontWeightX: `normal`,
                        textFontStyleX: `normal`,
                        textFontFamilyX: `sans-serif`,
                        textRowsBreakAuto: false,
                        textRowsNum: ``,
                        textIntervalX: 0,
                        textAngleX: 0,
                        isShowAxisLineX: true,
                        reversalX: false,
                        lineColorX: `#fff`,
                        lineWidthX: 1,
                        nameX: ``,
                        nameLocationX: `end`,
                        nameColorX: `#fff`,
                        nameFontSizeX: 14,
                        nameFontWeightX: `normal`,
                        nameFontStyleX: `normal`,
                        nameFontFamilyX: `sans-serif`,
                        isShowSplitLineX: false,
                        splitLineColorX: `#fff`,
                        splitLineWidthX: 1,
                        isShowY: true,
                        isShowAxisLabelY: true,
                        maxY: ``,
                        positionY: `left`,
                        offsetY: 0,
                        textColorY: `#fff`,
                        textFontSizeY: 14,
                        textFontWeightY: `normal`,
                        textFontStyleY: `normal`,
                        textFontFamilyY: `sans-serif`,
                        scale: false,
                        splitNumberY: 0,
                        textAngleY: 0,
                        isShowAxisLineY: true,
                        reversalY: false,
                        lineColorY: `#fff`,
                        lineWidthY: 1,
                        textNameY: ``,
                        nameLocationY: `end`,
                        nameColorY: `#fff`,
                        nameFontSizeY: 14,
                        nameFontWeightY: `normal`,
                        nameFontStyleY: `normal`,
                        nameFontFamilyY: `sans-serif`,
                        isShowSplitLineY: false,
                        splitLineColorY: `#fff`,
                        splitLineWidthY: 1,
                        isShowLegend: true,
                        legendName: `国产药品再注册申请|药品补充申请`,
                        legendColor: `#fff`,
                        legendFontSize: 12,
                        legendFontWeight: `normal`,
                        legendFontStyle: `normal`,
                        legendFontFamily: `sans-serif`,
                        legendWidth: 12,
                        legendHeight: 12,
                        lateralPosition: `center`,
                        longitudinalPosition: `top`,
                        layoutFront: `horizontal`,
                        isShow: false,
                        percentSign: false,
                        fontPosition: `top`,
                        fontDistance: -10,
                        fontColor: `#fff`,
                        fontSize: 12,
                        fontWeight: `normal`,
                        fontStyle: `normal`,
                        fontFamily: `sans-serif`,
                        isShowTooltip: true,
                        tooltipTrigger: `axis`,
                        tooltipAxisPointerType: `shadow`,
                        tooltipFontSize: 16,
                        tooltipColor: `#00FEFF`,
                        tooltipFontWeight: `normal`,
                        tooltipFontStyle: `normal`,
                        tooltipFontFamily: `sans-serif`,
                        marginLeft: 10,
                        marginRight: 50,
                        marginTop: 50,
                        marginBottom: 10,
                        customColor: [{
                            color: `rgb(73, 146, 255)`
                        }, {
                            color: `rgb(124, 255, 178)`
                        }, {
                            color: `rgb(253, 221, 96)`
                        }, {
                            color: `rgb(255, 110, 118)`
                        }, {
                            color: `rgb(88, 217, 249)`
                        }, {
                            color: `rgb(5, 192, 145)`
                        }],
                        tipsColor: `#fff`
                    }
                },
                screentype: `w`,
                readDataPermission: {
                    charttool5k2q: true,
                    charttoolpl1a: true,
                    charttoolxu53: true,
                    charttoolxmf5: true,
                    charttooltq94: true,
                    numeojk: true,
                    num274l: true,
                    num30ks: true,
                    titleuksa: true,
                    title474x: true,
                    title7yab: true,
                    title332a: true,
                    chartuq0d: true,
                    title7ooz: true,
                    gropa39a: true,
                    titlejyqs: true,
                    titlewt45: true,
                    titleu3s0: true,
                    title3ywz: true,
                    titlek353: true,
                    titlee8mw: true,
                    num259s0: true,
                    sel171443877146139: true,
                    numyjae: true,
                    numfeav: true,
                    numnrrv: true,
                    num567k: true,
                    num5rlv: true,
                    titlefj9r: true,
                    titlef9tz: true,
                    num67rw: true,
                    titlewtpl: true,
                    titlem074: true,
                    titles3zr: true,
                    titlec8s2: true,
                    lab2fbp: true,
                    img1jxh: true,
                    gropapgy: true,
                    sel171443848275890: true,
                    sel171443870260087: true,
                    grop17144387495475: true,
                    labjf0o: true
                }
            }
        },
        components: {
            custom1949993436471939073,
            custom1949989328457355266
        }
    }
</script>
<style scoped>
    .dv-full-screen-container {
        transform: scale(1);
        position: absolute;
        top: 0px;
        left: 0px;
        overflow: hidden;
        transform-origin: left top;
        z-index: 499;
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        width: 1920px;
        height: 1080px;
        background-color: '#040404';
        background-size: cover;
        background-repeat: no-repeat;
    }

    .div-full-screen {
        background-size: cover;
        background-repeat: no-repeat;
    }

    .bigitem {
        position: absolute;
        will-change: transform;
    }

    .bigechartitem:hover {
        z-index: 1900 !important;
    }

    .layouttable {
        height: 100%;
        display: flex;
    }

    .layouttable .layouttable-item {
        height: 100%;
        position: relative;
        float: left;
    }

    .itemcontent {
        width: 100%;
        height: 100%;
    }

    .bigbutton {
        width: 100%;
        height: 100%;
        text-align: center;
    }
</style>
<style scoped></style>